module.exports = __webpack_public_path__ + "img/erroe_desk_404.bf1ec8d9.png";